

import throttle from './../helpers/throttle.js';

const $window = $(window);


export default function(options) {

	const settings = $.extend({
		threshold: -100,
		handler: function() {} // default no-op handler
	}, options);

	return this.each(function() {
		const $this = $(this);

		// throttle event
		const throttledHandler = throttle(handler, 100);

		function handler() {
			const scroll = $(window).scrollTop();
			const height = $(window).height();
			const top = $this.offset().top;
			const calc = ((scroll+height)-top);

			if (calc > settings.threshold) {
				settings.handler();
				// run only once
				$(window).off('scroll resize orientationchange', throttledHandler);
			}
		}

		// setup initial event
		$(window).on('scroll resize orientationchange', throttledHandler);

		// do initial load event
		handler();
	});
}


